/**
 *
 * CustomProgress
 *
 */

import { CircularProgress, withStyles } from '@material-ui/core';
import PropTypes from 'prop-types';
import React from 'react';

import styles from './styles';

/**
 * @internal
 */
function CustomProgress({ classes, page }) {
  return <CircularProgress className={`${page && classes.page}`} />;
}

CustomProgress.propTypes = {
  classes: PropTypes.object.isRequired,
  page: PropTypes.bool,
};

CustomProgress.defaultProps = {
  page: false,
};

/**
 * @internal
 */
export default withStyles(styles)(CustomProgress);
